// src/components/QuickConsult.jsx
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LeadsAPI } from '../api/public';

const TELEGRAM_URL = process.env.REACT_APP_TELEGRAM_URL || 'https://t.me/+79309729797';

const Card = styled.section`
  margin: 20px 0;
  padding: 16px;
  border: 1px solid var(--bdr);
  border-radius: 16px;
  background: var(--card);
  box-shadow: var(--shadow);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
`;
const Grid = styled.div`
  display:grid; gap:12px; grid-template-columns: 1fr 1fr 1fr;
  @media (max-width: 980px){ grid-template-columns:1fr; }
`;
const Field = styled.div`display:flex; flex-direction:column; gap:6px;`;
const Label = styled.label`font-size:13px; color:var(--muted);`;
const Input = styled.input`
  padding:12px 14px; border-radius:12px; border:1px solid var(--bdr);
  background:var(--card); color:inherit;
`;
const Text  = styled.textarea`
  grid-column: 1/-1; min-height:120px;
  padding:12px 14px; border-radius:12px; border:1px solid var(--bdr);
  background:var(--card); color:inherit;
`;
const Actions = styled.div`margin-top: 10px; display:flex; gap:10px; justify-content:flex-end;`;

// transient-проп $primary — не попадёт в DOM
const Btn = styled.button`
  padding:12px 16px; border-radius:12px; font-weight:700; cursor:pointer;
  border:1px solid var(--bdr);
  background:${p=>p.$primary ? 'var(--primary)' : 'transparent'};
  color:${p=>p.$primary ? 'var(--primaryFg)' : 'inherit'};
`;

const Alert = styled.div`
  margin-top: 8px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid ${p => p.$type === 'ok' ? '#2e7d32' : '#c62828'};
  background: ${p => p.$type === 'ok' ? 'rgba(46, 125, 50, .08)' : 'rgba(198, 40, 40, .08)'};
  color: ${p => p.$type === 'ok' ? '#2e7d32' : '#c62828'};
  position: relative;
`;
const AlertClose = styled.button`
  position:absolute; top:8px; right:8px;
  width:28px; height:28px; border-radius:8px;
  border:1px solid currentColor;
  background:transparent; color:inherit; cursor:pointer;
  line-height:1; font-size:16px;
`;

export default function QuickConsult(){
  const { t } = useTranslation();
  const [name,setName] = React.useState('');
  const [phone,setPhone] = React.useState('');
  const [email,setEmail] = React.useState('');
  const [comment,setComment] = React.useState('');
  const [ok, setOk] = React.useState('');
  const [err, setErr] = React.useState('');

  const okTimerRef = React.useRef(null);

  React.useEffect(() => {
    return () => {
      if (okTimerRef.current) clearTimeout(okTimerRef.current);
    };
  }, []);

  const send = async (e)=>{
    e.preventDefault();
    setOk(''); setErr('');
    if (okTimerRef.current) { clearTimeout(okTimerRef.current); okTimerRef.current = null; }

    const digits = (phone || '').replace(/\D/g,'');
    if (!name.trim() || digits.length < 11) {
      setErr(t('contactForm.errorNamePhone'));
      return;
    }

    const payload = {
      first_name: name.trim(),
      phone,
      email: email || undefined,
      message: comment || undefined,
      source_page: typeof window !== 'undefined' ? window.location.pathname : undefined,
      utm_source: localStorage.getItem('utm_source') || undefined,
      utm_medium: localStorage.getItem('utm_medium') || undefined,
      utm_campaign: localStorage.getItem('utm_campaign') || undefined,
      device_id: localStorage.getItem('device_id') || undefined,
      consent_privacy: true,
      consent_marketing: false,
    };

    try {
      await LeadsAPI.consultation(payload);
      setOk(t('contactForm.ok'));
      setName(''); setPhone(''); setEmail(''); setComment('');
      // авто-скрытие баннера через 5 сек (можно закрыть крестиком)
      okTimerRef.current = setTimeout(() => {
        setOk('');
        okTimerRef.current = null;
      }, 5000);
    } catch (e) {
      setErr(String(e.message || e));
    }
  };

  return (
    <Card>
      <form onSubmit={send}>
        <Grid>
          <Field>
            <Label>{t('contactForm.name')}</Label>
            <Input value={name} onChange={e=>setName(e.target.value)} placeholder="Лилия / Liliya" />
          </Field>
          <Field>
            <Label>{t('contactForm.phone')}</Label>
            <Input value={phone} onChange={e=>setPhone(e.target.value)} placeholder="+7XXXXXXXXXX" />
          </Field>
          <Field>
            <Label>{t('contactForm.email')}</Label>
            <Input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@email.com" />
          </Field>
          <Text value={comment} onChange={e=>setComment(e.target.value)} placeholder={t('contactForm.message')} />
        </Grid>

        {ok && (
          <Alert $type="ok">
            {ok}
            <AlertClose onClick={() => { setOk(''); if (okTimerRef.current) { clearTimeout(okTimerRef.current); okTimerRef.current = null; } }} aria-label="Dismiss">×</AlertClose>
          </Alert>
        )}
        {err && (
          <Alert $type="err">
            {err}
            <AlertClose onClick={() => setErr('')} aria-label="Dismiss">×</AlertClose>
          </Alert>
        )}

        <Actions>
          <Btn as="a" href={TELEGRAM_URL} target="_blank" rel="noreferrer">{t('telegram')}</Btn>
          <Btn $primary type="submit">{t('contactForm.send')}</Btn>
        </Actions>
      </form>
    </Card>
  );
}
